export default __webpack_public_path__ + "static/indian-elephant-4cfa5393e8840d0674727cc6d9961a5e.jpg";